import { Button } from '@/components/ui/button';
import { EquipmentTypeDisplay } from '@/nodes/NodeUI';
import type { EquipmentTypeIdOrContext, HelpType, SpaceId } from '@rock/types';
import type { FC } from 'react';

type HelpTypePreviewProps = {
    helpType: HelpType | undefined;
    spaceId: SpaceId;
    modelHelpTypeId?: EquipmentTypeIdOrContext;
    helpMeDecideEnabled?: boolean;
    modelNumberHelpEnabled?: boolean;
};

export const HelpTypePreview: FC<HelpTypePreviewProps> = ({
    helpType,
    spaceId,
    modelHelpTypeId,
    helpMeDecideEnabled = true,
    modelNumberHelpEnabled = true,
}) => {
    // Absent means no help — matching GuideHelpLink. The canvas reads draft flows unparsed, so a
    // node authored before helpType existed arrives undefined and correctly previews as no link.
    if (helpType === 'help-me-decide' && helpMeDecideEnabled) {
        return (
            <Button variant="link" size="sm" className="h-6 text-xs italic text-blue-600">
                Help Me Decide
            </Button>
        );
    }
    if (helpType === 'model-number-help' && modelNumberHelpEnabled) {
        return (
            <>
                <Button variant="link" size="sm" className="h-6 text-xs italic text-blue-600">
                    Help Finding Model Number
                </Button>
                {modelHelpTypeId && <EquipmentTypeDisplay spaceId={spaceId} typeId={modelHelpTypeId} />}
            </>
        );
    }
    return null;
};
